import { FunctionComponent, useState } from 'react';
import { StudiesCompletedCRUD, StudiesInProgressCRUD } from '../../components/GeneratedComponents';
import '../../css/PrivateAdminStudiesPage.css';

const PrivateAdminStudiesPage: FunctionComponent = () => {
  const [studyStatus, setStudyStatus] = useState<'inProgress' | 'completed'>('inProgress');

  return (
    <div className='private-admim-studies-page-container'>
      <header className='vdr-page-head vdr-admin-studies-head'>
        <div className='vdr-page-head__titles'>
          <span className='vdr-eyebrow vdr-eyebrow--bar'>Administrador</span>
          <h2 className='vdr-page-head__title'>Estudios</h2>
        </div>
      </header>

      <div className='private-admim-studies-page-buttons-container'>
        <button
          className={`clear-button-style ${
            studyStatus === 'inProgress' ? 'clear-button-style-checked' : ''
          }`}
          onClick={() => setStudyStatus('inProgress')}>
          En Proceso
        </button>
        <button
          className={`clear-button-style ${
            studyStatus === 'completed' ? 'clear-button-style-checked' : ''
          }`}
          onClick={() => setStudyStatus('completed')}>
          Terminados
        </button>
      </div>

      <div>
        {studyStatus === 'inProgress' ? (
          <StudiesInProgressCRUD />
        ) : studyStatus === 'completed' ? (
          <StudiesCompletedCRUD />
        ) : null}
      </div>
    </div>
  );
};

export default PrivateAdminStudiesPage;
